﻿class TolhuinBundleBuilder extends HTMLElement {
  connectedCallback() {
    this.selection = [];
    this.currency = this.dataset.currency || 'CZK';
    this.country = this.dataset.country || 'your location';
    this.countryCode = this.dataset.countryCode || '';
    this.freeShippingThreshold = Number(this.dataset.freeShippingThreshold || 0);
    this.shippingPrice = this.dataset.shippingPrice || 'Shown at checkout';
    this.cartUrl = this.dataset.cartUrl || window.routes.cart_url;
    this.i18n = this.dataset;
    this.variants = {
      6: this.parseVariants(this.getAttribute('data-product-6')),
      12: this.parseVariants(this.getAttribute('data-product-12')),
    };
    this.createDialog();
    this.bindEvents();
    this.preselectFlavour();
    this.render();
  }

  parseVariants(value) {
    try { return JSON.parse(value || '{}'); } catch (_) { return {}; }
  }

  preselectFlavour() {
    const requestedName = new URLSearchParams(window.location.search).get('flavour');
    if (!requestedName) return;
    const card = Array.from(this.querySelectorAll('[data-flavour]'))
      .find((item) => item.dataset.flavour.toLowerCase() === requestedName.toLowerCase());
    if (!card || card.dataset.soldOut === 'true') return;
    this.selection.push({
      name: card.dataset.flavour,
      special: card.dataset.special === 'true',
      image: card.dataset.image,
      color: card.dataset.color,
    });
  }

  bindEvents() {
    this.querySelectorAll('[data-flavour-action]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('[data-flavour]');
        if (card.dataset.soldOut === 'true') return;
        if (button.dataset.flavourAction === 'add') {
          if (this.selection.length < 12) this.selection.push({
            name: card.dataset.flavour,
            special: card.dataset.special === 'true',
            image: card.dataset.image,
            color: card.dataset.color,
          });
        } else {
          const index = this.selection.map((item) => item.name).lastIndexOf(card.dataset.flavour);
          if (index >= 0) this.selection.splice(index, 1);
        }
        this.render();
      });
    });
    this.querySelectorAll('[data-info]').forEach((button) => button.addEventListener('click', () => this.openDialog(button)));
    this.querySelector('[data-slots]').addEventListener('click', (event) => {
      const remove = event.target.closest('[data-remove-slot]');
      if (!remove) return;
      this.selection.splice(Number(remove.dataset.removeSlot), 1);
      this.render();
    });
    this.querySelector('[data-add-bundle]').addEventListener('click', () => this.addToCart());
    const mobileToggle = this.querySelector('[data-mobile-summary-toggle]');
    if (mobileToggle) {
      mobileToggle.addEventListener('click', () => {
        const expanded = this.querySelector('.tol-builder__summary').classList.toggle('is-expanded');
        mobileToggle.setAttribute('aria-expanded', String(expanded));
        mobileToggle.querySelector('span:last-child').textContent = expanded ? '⌄' : '⌃';
      });
    }
  }

  createDialog() {
    this.dialog = document.createElement('dialog');
    this.dialog.className = 'tol-builder-dialog';
    this.dialog.innerHTML = `
      <form method="dialog">
        <header><h2 data-dialog-name></h2><button aria-label="${this.i18n.i18nClose}">&times;</button></header>
        <div class="tol-builder-dialog__body">
          <div class="tol-builder-dialog__image" data-dialog-image></div>
          <div data-dialog-badges></div><p data-dialog-description></p>
          <h3>${this.i18n.i18nIngredients}</h3><p data-dialog-ingredients></p>
          <h3>${this.i18n.i18nAllergens}</h3><p data-dialog-allergens></p>
        </div>
        <footer><button class="button button--secondary">${this.i18n.i18nClose}</button></footer>
      </form>`;
    document.body.appendChild(this.dialog);
  }

  openDialog(button) {
    this.dialog.querySelector('[data-dialog-name]').textContent = button.dataset.name;
    this.dialog.querySelector('[data-dialog-description]').textContent = button.dataset.description || this.i18n.i18nMoreDetails;
    this.dialog.querySelector('[data-dialog-ingredients]').textContent = button.dataset.ingredients || this.i18n.i18nIngredientInfo;
    this.dialog.querySelector('[data-dialog-allergens]').textContent = button.dataset.allergens || this.i18n.i18nAllergenInfo;
    const image = this.dialog.querySelector('[data-dialog-image]');
    image.style.setProperty('--flavour-color', button.dataset.color);
    image.innerHTML = button.dataset.image ? `<img src="${button.dataset.image}" alt="${button.dataset.name}">` : '<span>◇</span>';
    this.dialog.querySelector('[data-dialog-badges]').innerHTML =
      `<span class="tol-flavour-card__badge">${button.dataset.category}</span>${button.dataset.special === 'true' ? `<span class="tol-flavour-card__badge">+${button.dataset.specialPrice}</span>` : ''}`;
    this.dialog.showModal();
  }

  boxSize() { return this.selection.length <= 6 ? 6 : 12; }
  specialCount() { return this.selection.filter((item) => item.special).length; }
  optionName() { const count = this.specialCount(); return `${count} ${count === 1 ? 'especial' : 'especiales'}`; }
  selectedVariant() {
    const variants = this.variants[this.boxSize()] || {};
    const exact = variants[this.optionName()];
    if (exact) return exact;

    const specialCount = String(this.specialCount());
    const localizedKey = Object.keys(variants).find((key) => {
      const normalized = key.toLowerCase().trim();
      return normalized === specialCount || normalized.startsWith(`${specialCount} `);
    });

    return localizedKey ? variants[localizedKey] : null;
  }

  formatMoney(cents) {
    const locale = document.documentElement.lang || 'en';
    if (this.currency === 'CZK') return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(cents / 100)} Kč`;
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  }

  render() {
    const count = this.selection.length;
    const size = this.boxSize();
    const specials = this.specialCount();
    const selectedVariant = this.selectedVariant();
    const total = selectedVariant ? Number(selectedVariant.price) : 0;
    const amountLeft = Math.max(this.freeShippingThreshold - total, 0);
    const freeShippingUnlocked = this.countryCode === 'CZ'
      ? count === 12
      : this.freeShippingThreshold > 0 && amountLeft === 0;
    const complete = count === 6 || count === 12;

    this.querySelectorAll('[data-flavour]').forEach((card) => {
      const quantity = this.selection.filter((item) => item.name === card.dataset.flavour).length;
      const chosen = card.querySelector('[data-chosen]');
      chosen.hidden = quantity === 0;
      chosen.textContent = `${quantity}×`;
      card.querySelector('[data-flavour-action="remove"]').hidden = quantity === 0;
      card.classList.toggle('is-chosen', quantity > 0);
    });

    const slots = this.querySelector('[data-slots]');
    slots.innerHTML = '';
    for (let index = 0; index < 12; index += 1) {
      const slot = document.createElement('div');
      slot.className = `tol-builder__slot${index >= 6 ? ' tol-builder__slot--second' : ''}${this.selection[index] ? ' is-filled' : ''}`;
      if (this.selection[index]) {
        const item = this.selection[index];
        slot.style.setProperty('--flavour-color', item.color);
        slot.innerHTML = `${item.image ? `<img src="${item.image}" alt="">` : '<span class="tol-builder__slot-placeholder">◇</span>'}<small>${item.name}</small><button type="button" data-remove-slot="${index}" aria-label="${this.i18n.i18nRemove} ${item.name}">×</button>`;
      } else {
        slot.innerHTML = `<span>${index + 1}</span>`;
      }
      slots.appendChild(slot);
    }

    this.querySelector('[data-progress]').style.width = `${(count / 12) * 100}%`;
    this.querySelector('[data-total]').textContent = selectedVariant ? this.formatMoney(total) : '—';
    this.querySelector('[data-summary-heading]').textContent =
      count < 6 ? this.i18n.i18nComplete6 : count === 6 ? this.i18n.i18nReady6 : count < 12 ? this.i18n.i18nKeep12 : this.i18n.i18nReady12;
    const freeShippingLabel = this.countryCode === 'CZ'
      ? this.i18n.i18nFreePickup
      : `${this.i18n.i18nFreeTo} ${this.country}`;
    this.querySelector('[data-shipping-message]').textContent =
      freeShippingUnlocked
        ? `${freeShippingLabel} ${this.i18n.i18nUnlocked}!`
        : this.countryCode === 'CZ'
          ? this.i18n.i18nAddMore.replace('{count}', 12 - count).replace('{label}', freeShippingLabel)
        : selectedVariant
          ? this.i18n.i18nSpendMore.replace('{amount}', this.formatMoney(amountLeft)).replace('{label}', freeShippingLabel)
          : this.i18n.i18nStart;
    this.querySelector('[data-free-shipping]').hidden = !freeShippingUnlocked;

    const button = this.querySelector('[data-add-bundle]');
    button.disabled = !complete || !selectedVariant;
    button.textContent = complete
      ? this.i18n.i18nAddBox.replace('{count}', count)
      : count < 6
        ? this.i18n.i18nAddMore6.replace('{count}', 6 - count)
        : this.i18n.i18nAddMore12.replace('{count}', 12 - count);
    this.querySelector('[data-message]').textContent =
      complete && !this.selectedVariant() ? this.i18n.i18nEditor : '';
  }

  async addToCart() {
    const variant = this.selectedVariant();
    if (!variant || ![6, 12].includes(this.selection.length)) return;
    const quantities = {};
    this.selection.forEach(({ name }) => { quantities[name] = (quantities[name] || 0) + 1; });
    const flavours = Object.entries(quantities).map(([name, quantity]) => `${name} x${quantity}`).join(', ');
    const button = this.querySelector('[data-add-bundle]');
    button.disabled = true;
    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: {
          [this.i18n.i18nPropBoxSize]: this.selection.length,
          [this.i18n.i18nPropSpecials]: this.specialCount(),
          [this.i18n.i18nPropFlavours]: flavours,
        } }] }),
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Cart request failed');
      }
      window.location.href = this.cartUrl;
    } catch (error) {
      this.querySelector('[data-message]').textContent = `${this.i18n.i18nError} ${error.message}`;
      button.disabled = false;
    }
  }
}

if (!customElements.get('tolhuin-bundle-builder')) customElements.define('tolhuin-bundle-builder', TolhuinBundleBuilder);
